import { render } from "./TestTake.vue?vue&type=template&id=997b230a&scoped=true"
import script from "./TestTake.vue?vue&type=script&lang=js"
export * from "./TestTake.vue?vue&type=script&lang=js"

import "./TestTake.vue?vue&type=style&index=0&id=997b230a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-997b230a"]])

export default __exports__